import React from 'react';
import { Property } from '@go-shared/types/property';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';
import { VenueDispositionWithTemplate } from '@go-shared/lib/mealPeriods';
import { DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT, timeToString } from '@go-shared/lib/time';
import DraggableContentItem from '@go-client/components/DraggableContentItem';

interface VenueBlurbsProps {
  venues: VenueDispositionWithTemplate[];
  property: Property;
}
export const VenueBlurbs: React.FC<VenueBlurbsProps> = ({ venues, property }) => {
  return (
    <div className="flex justify-center flex-wrap">
      {venues.map(v => (
        <DraggableContentItem
          key={v.template._id}
          contentTemplate={venueToContentTemplate(v, property)}
        />
      ))}
    </div>
  );
};

const venueToContentTemplate = (
  venue: VenueDispositionWithTemplate,
  property: Property
): BareContentTemplateLegacy => {
  return {
    _id: venue.template._id,
    content: venueDispositionContent(venue),
    name: venue.template.name,
    property: property._id,
    params: {
      venueId: venue.template._id,
    },
  };
};

export const venueDispositionContent = (vd: VenueDispositionWithTemplate): string => {
  let content = '<div>';
  let venueHours = '';
  let mealPeriods = '';
  vd.venueHours.forEach(vhs => {
    vhs.forEach(vh => {
      venueHours += '<p class="mb-2">';
      venueHours += timeToString(vh.startTime, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT);
      venueHours += ' - ';
      venueHours += timeToString(vh.endTime, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT);
      venueHours += '</p>';
    });
  });

  vd.venueMealperiods.forEach(vms => {
    vms.forEach(vm => {
      mealPeriods += '<p class="mb-2">';
      mealPeriods += timeToString(vm.startTime, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT);
      mealPeriods += ' - ';
      mealPeriods += timeToString(vm.endTime, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT);
      mealPeriods += '</p>';
    });
  });
  return content + venueHours + mealPeriods + '</div>';
};
